/**
 * Client de l'API Ermont Live (même origine). Le front n'appelle JAMAIS un fournisseur externe
 * directement (hors tuiles cartographiques) : voir docs/04.
 */
export class ApiError extends Error {
  override readonly name = 'ApiError';
  constructor(
    readonly status: number,
    message: string,
  ) {
    super(message);
  }
}

const TIMEOUT_MS = 10_000;

export async function getJson<T>(path: string, signal?: AbortSignal): Promise<T> {
  const timeout = AbortSignal.timeout(TIMEOUT_MS);
  const response = await fetch(path, {
    headers: { accept: 'application/json' },
    signal: signal === undefined ? timeout : AbortSignal.any([signal, timeout]),
  });
  if (!response.ok) throw new ApiError(response.status, `Erreur ${response.status} sur ${path}`);
  return (await response.json()) as T;
}
